import SuperFetch from 'library/helpers/superFetch';
import { call, put, takeLatest } from 'redux-saga/effects';
import { typesActions } from './slice';

/**
 * Fetches all reference types in a single API call.
 * GET /misc/types returns all 13 type arrays in one response.
 */
export function* loadAllTypes() {
	try {
		const res = yield call(() => SuperFetch.get('/misc/types'));

		if (res.statusCode === 200) {
			yield put(typesActions.loadAllTypesSuccess(res.data));
		} else {
			throw new Error(res.error?.message || 'Failed to load types');
		}
	} catch (error) {
		yield put(typesActions.loadAllTypesError(error.message));
	}
}

// Exception: IR sync refreshes card templates only (socket-triggered)
function* loadCardTemplatesTypes() {
	try {
		const res = yield call(() => SuperFetch.get('/credentials/templates'));
		if (res.statusCode === 200) {
			const data = res.data.filter ? res.data.filter((item) => !item.deletedDate) : res.data;
			yield put(typesActions.loadCardTemplatesTypesSuccess(data));
		} else {
			throw new Error(res.error?.message || 'Failed to load card templates');
		}
	} catch (error) {
		yield put(typesActions.loadCardTemplatesTypesError());
	}
}

// Root saga
export default function* rootSaga() {
	yield takeLatest(typesActions.loadAllTypes, loadAllTypes);
	yield takeLatest(typesActions.loadCardTemplatesTypes, loadCardTemplatesTypes);
}
